import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import StoreSelect from '../../Components/Store';

const Customers = () => {
    const { apiUrl, apiHeadersJson, store_id } = useContext(ConfigContext);
    const [CustomerName, setCustomerName] = useState('');
    const [CustomerPhone, setCustomerPhone] = useState('');
    const [CustomerAddress, setCustomerAddress] = useState('');
    const [CustomerId, setCustomerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState('');
    const headers = apiHeadersJson;
    const toast = useRef(null);


    const HandleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const body = {
            store_id: store_id,
            customer_name: CustomerName,
            customer_contact: CustomerPhone,
            customer_address: CustomerAddress,
            customer_id: CustomerId,
        };

        try {
            const response = await axios.post(`${apiUrl}/Masters/CreateCustomer`, body, { headers });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    };

    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetCustomerList`, { params: { keyword, store_id: store_id }, headers });
            const { success, data, message } = response.data;

            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    const handleResetForm = () => {
        setCustomerId(null);
        setCustomerPhone('');
        setCustomerName('');
        setCustomerAddress('');
    };

    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this customer?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeleteCustomer(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeleteCustomer = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Masters/DeleteCustomer`, { params: { customer_id: id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const GetInfo = async (id) => {
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetCustomerInfo`, { params: { customer_id: id }, headers });
            const { success, data, message } = response.data;
            if (success) {
                setCustomerId(data[0].customer_id);
                setCustomerName(data[0].customer_name);
                setCustomerPhone(data[0].customer_contact);
                setCustomerAddress(data[0].customer_address);
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000, });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (keyword) {
                GetList();
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [keyword]);

    useEffect(() => {
        GetList();
    }, [store_id]);

    useEffect(() => {
        store_id && handleResetForm();
    }, [store_id]);


    const ActionBody = (data) => {
        return (
            <>
                <Button icon="pi pi-pencil" outlined onClick={() => GetInfo(data.customer_id)} />
                <Button outlined className='ms-3' icon="pi pi-trash" severity="danger" onClick={() => confirmDelete(data.customer_id)} />
            </>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center my-4">
                    <div className="main-heading">
                        <h6>Customer</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Masters/Customer</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="card">
                            <div className=" bg-dark text-white p-3 rounded-top  d-flex flex-wrap justify-content-between align-items-center">
                                <h4>Customer</h4>

                            </div>
                            <form className='p-3' onSubmit={HandleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 my-1">
                                        <label className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            value={CustomerName}
                                            className="form-control"
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            required={true}
                                            placeholder='Enter Customer Name'
                                        />
                                    </div>
                                    <div className="col-md-12 my-1">
                                        <label className="form-label">Phone</label>
                                        <input
                                            type="number"
                                            value={CustomerPhone}
                                            className="form-control"
                                            onChange={(e) => setCustomerPhone(e.target.value)}
                                            placeholder='Enter Customer Phone'
                                        />
                                    </div>
                                    <div className="col-md-12 my-1">
                                        <label className="form-label">Address</label>
                                        <textarea
                                            type="text"
                                            rows={3}
                                            value={CustomerAddress}
                                            className="form-control"
                                            onChange={(e) => setCustomerAddress(e.target.value)}
                                            placeholder='Enter Customer Address'
                                        />
                                    </div>
                                    {!CustomerId && <div className="col-md-12 text-end my-3">
                                        <Button className="btn btn-success mt-3" type="submit" size='small' label="Submit" icon="pi pi-check" loading={loading} />
                                    </div>}
                                </div>

                                {CustomerId &&
                                    <div>
                                        <Button
                                            size='small'
                                            type="submit"
                                            label={loading ? "Loading..." : "Update"}
                                            className="btn btn-success mt-3"
                                            disabled={loading || !store_id}
                                        />
                                        <Button
                                            type="button"
                                            size='small'
                                            onClick={handleResetForm}
                                            label={loading ? "Loading..." : "Reset"}
                                            className=" btn btn-light mt-3 float-end"
                                            disabled={loading || !store_id}
                                        />
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="card">
                            <div className="bg-dark text-white p-3 rounded-top d-flex flex-wrap justify-content-between align-items-center">
                                <h4>Customer List</h4>
                                <IconField iconPosition="left" style={{ width: '35%' }}>
                                    <InputIcon className="pi pi-search"> </InputIcon>
                                    <InputText
                                        className='w-100'
                                        placeholder='Search By Customer Name...'
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </IconField>
                            </div>
                            <div className="p-3">
                                <DataTable
                                    value={rows}
                                    paginator
                                    rows={10}
                                    loading={dataTableLoading}
                                >
                                    <Column field="store_name" header="Store" />
                                    <Column field="customer_name" header="Name" />
                                    <Column field="customer_contact" header="Phone" />
                                    <Column field="customer_address" header="Address" />
                                    <Column body={ActionBody} header="Actions" />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Customers;

